var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6663 22C7.23987 22 6.81323 21.8372 6.48825 21.5117C5.83725 20.8608 5.83725 19.8061 6.48825 19.1551L13.6451 12.0007L6.48825 4.84487C5.83725 4.19387 5.83725 3.13925 6.48825 2.48825C7.13925 1.83725 8.19387 1.83725 8.84487 2.48825L17.1777 10.821C17.8287 11.472 17.8287 12.5267 17.1777 13.1777L8.84487 21.5104C8.51937 21.8386 8.09283 22 7.6663 22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.8ac9f6892a7657673ba6726d02414424.svg";
export { ForwardRef as ReactComponent };